import { Button, ButtonProps, useDisclosure } from "@chakra-ui/react";
import { __ } from "@wordpress/i18n";
import React from "react";
import { withChakraUIProvider } from "../../hoc";
import LibraryModal from "./LibraryModal";

export const LibraryModalTrigger = withChakraUIProvider(
	({
		label,
		...props
	}: {
		label?: string;
	} & ButtonProps) => {
		const { isOpen, onOpen, onClose } = useDisclosure();
		return (
			<>
				<Button
					onClick={onOpen}
					size="sm"
					fontSize="13px"
					leftIcon={
						<svg
							width={20}
							height={20}
							xmlns="http://www.w3.org/2000/svg"
							viewBox="0 0 24 24"
						>
							<path d="M22 22H2V2h20zM3 21h18V3H3z" fill="#fff" />
							<path
								d="M13.46 10l-1.39-5-1.39 5zm.92 3H9.77l-1 4.46V19h6.4v-1.52z"
								fill="#fff"
								fillRule="evenodd"
							/>
						</svg>
					}
					{...props}
				>
					{label
						? label
						: __("Magazine Blocks Library", "magazine-blocks")}
				</Button>
				<LibraryModal isOpen={isOpen} onClose={onClose} />
			</>
		);
	}
);

export default LibraryModalTrigger;
